import * as yup from "yup";

export type PuchaseInfoType = yup.InferType<typeof PurchaseInfoValidation>;

export const PurchaseInfoValidation = yup.object().shape({
	Purchaser_Name: yup.string(),
	Vendor: yup.string(),
	Account_Name: yup.string(),
	Credit_Card: yup.string(),
});
